import { MySquid, onConfigChange } from '@hub/shared'
import { useEffect, useRef, useState } from 'react'
import { SubscriptionLike } from 'rxjs'
import './empty-page.component.scoped.scss'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  title?: any
  description?: any
  image?: any
  icon?: string
  link?: string
  linkText?: string
}

export default ({ title = '', description = '', className = '', style = {}, image, icon, link = null, linkText = '' }: Props) => {
  const [configs, setConfig] = useState<MySquid>(null)
  const onConfigChangeSubscription = useRef<SubscriptionLike | undefined>(undefined)

  useEffect(() => {
    onConfigChangeSubscription.current = onConfigChange.subscribe((configChanged: MySquid) => {
      if (configChanged?._id) {
        setConfig(configChanged)
      }
    })
    return () => {
      onConfigChangeSubscription.current?.unsubscribe()
    }
  }, [onConfigChangeSubscription])

  return (
    <div className={`empty-engage ${className}`} style={style}>
      <figure>
        {configs?._id ? <i className={`icon-figure ${icon}`}></i> : <img className="img-fluid" title={title} alt={title} src={image} />}
      </figure>
      {title && <h3>{title}</h3>}
      {description && <p>{description}</p>}
      {link && (
        <a className="button button-external-link mt-3" target="_blank" href={link}>
          <i className="mr-2 fa-regular fa-external-link"></i> {linkText}
        </a>
      )}
    </div>
  )
}
